import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { DepartmentActions, DepartmentActionTypes } from './department.actions';
import { Department } from './department.model';

export interface State extends EntityState<Department> {
  // additional entities state properties
}

export function sortByName(a: Department, b: Department): number {
  return a.name.localeCompare(b.name);
}

export const adapter: EntityAdapter<Department> = createEntityAdapter<Department>({
  sortComparer: sortByName,
});

export const initialState: State = adapter.getInitialState({
  // additional entity state properties
});

export function reducer(state = initialState, action: DepartmentActions): State {
  switch (action.type) {
    case DepartmentActionTypes.AddDepartment: {
      return adapter.addOne(action.payload.department, state);
    }

    case DepartmentActionTypes.UpsertDepartment: {
      return adapter.upsertOne(action.payload.department, state);
    }

    case DepartmentActionTypes.AddDepartments: {
      return adapter.addMany(action.payload.departments, state);
    }

    case DepartmentActionTypes.UpsertDepartments: {
      return adapter.upsertMany(action.payload.departments, state);
    }

    case DepartmentActionTypes.UpdateDepartment: {
      return adapter.updateOne(action.payload.department, state);
    }

    case DepartmentActionTypes.UpdateDepartments: {
      return adapter.updateMany(action.payload.departments, state);
    }

    case DepartmentActionTypes.DeleteDepartment: {
      return adapter.removeOne(action.payload.id, state);
    }

    case DepartmentActionTypes.DeleteDepartments: {
      return adapter.removeMany(action.payload.ids, state);
    }

    case DepartmentActionTypes.LoadDepartments: {
      return adapter.setAll(action.payload.departments, state);
    }

    case DepartmentActionTypes.ClearDepartments: {
      return adapter.removeAll(state);
    }

    default: {
      return state;
    }
  }
}

export const {
  selectIds,
  selectEntities,
  selectAll,
  selectTotal,
} = adapter.getSelectors();
